var _path, _path2, _line, _line2, _line3, _line4, _path3, _path4, _line5, _line6, _line7, _line8, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDemoDataLimitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 64,
    viewBox: "0 0 66 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 49.397 49.897 63.5 32.5 63.5C15.103 63.5 1 49.397 1 32C1 14.603 15.103 0.5 32.5 0.5C49.897 0.5 64 14.603 64 32Z",
    stroke: "white",
    strokeOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8496 34.8608L58.8666 36.2671C56.6048 39.503 52.9054 41.4307 48.9574 41.4307V41.4307C44.821 41.4307 40.9716 39.316 38.7532 35.8248L38.1406 34.8608",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 56.3131,
    y1: 38.506,
    x2: 58.5982,
    y2: 40.7912,
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 3.2317,
    y2: -0.7,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 41.5352 39.001)",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 3.2317,
    y2: -0.7,
    transform: "matrix(-0.318132 0.948047 0.948047 0.318132 46.9668 41.0811)",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 51.6011,
    y1: 40.8584,
    x2: 52.6292,
    y2: 43.9222,
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13141 36.022C9.39329 32.7861 13.0926 30.8584 17.0407 30.8584V30.8584C21.1771 30.8584 25.0264 32.9731 27.2449 36.4643L27.8574 37.4282L27.2449 38.3922C25.0264 41.8834 21.1771 43.998 17.0407 43.998V43.998C13.0926 43.998 9.39329 42.0704 7.13141 38.8345L6.14844 37.4282L7.13141 36.022Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2891 37.4282C13.2891 35.3774 14.9516 33.7148 17.0024 33.7148V33.7148C19.0533 33.7148 20.7158 35.3774 20.7158 37.4282V37.4282C20.7158 39.4791 19.0533 41.1416 17.0024 41.1416V41.1416C14.9516 41.1416 13.2891 39.4791 13.2891 37.4282V37.4282Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 9.65371,
    y1: 33.6385,
    x2: 7.36855,
    y2: 31.3534,
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 3.2317,
    y2: -0.7,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 24.4316 33.1436)",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 3.2317,
    y2: -0.7,
    transform: "matrix(0.318132 -0.948047 -0.948047 -0.318132 19 31.0635)",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 14.3657,
    y1: 31.2862,
    x2: 13.3376,
    y2: 28.2224,
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_4149_99051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8496 46.4611V46.4611C56.8641 48.6158 53.2758 49.7754 49.5939 49.7754L47.6459 49.7754C44.1942 49.7754 40.844 48.6073 38.1406 46.4611V46.4611",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 2.55947,
    y2: -0.7,
    transform: "matrix(0.892823 0.450408 -0.892823 0.450408 55.8181 48.5498)",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 2.55947,
    y2: -0.7,
    transform: "matrix(-0.892823 0.450408 0.892823 0.450408 41.5352 48.5498)",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 1.85632,
    y2: -0.7,
    transform: "matrix(-0.553841 0.832623 0.985972 0.16691 46.9668 49.5996)",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 1.85632,
    y2: -0.7,
    transform: "matrix(0.553841 0.832622 -0.985972 0.16691 50.9375 49.5996)",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter1_f_4149_99051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.709 46.4611V46.4611C24.7235 48.6158 21.1352 49.7754 17.4533 49.7754L15.5053 49.7754C12.0535 49.7754 8.70339 48.6073 6 46.4611V46.4611",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 2.55947,
    y2: -0.7,
    transform: "matrix(0.892823 0.450408 -0.892823 0.450408 23.6775 48.5498)",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 2.55947,
    y2: -0.7,
    transform: "matrix(-0.892823 0.450408 0.892823 0.450408 9.39453 48.5498)",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 1.85632,
    y2: -0.7,
    transform: "matrix(-0.553841 0.832623 0.985972 0.16691 14.8262 49.5996)",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.7,
    x2: 1.85632,
    y2: -0.7,
    transform: "matrix(0.553841 0.832622 -0.985972 0.16691 18.7969 49.5996)",
    stroke: "#1A1B1D",
    strokeWidth: 1.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4149_99051",
    x: 32.7054,
    y: 40.8936,
    width: 32.5539,
    height: 15.252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_4149_99051"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4149_99051",
    x: 0.564758,
    y: 40.8936,
    width: 32.5539,
    height: 15.252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_4149_99051"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoDataLimitation);
export default __webpack_public_path__ + "static/media/demo-data-limitation.8f6ec98d9dcba331d26bbde08539f7b5.svg";
export { ForwardRef as ReactComponent };